// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-5f215072]{margin:0 auto;line-height:46px;text-align:left;font-size:16px;color:#676767}.gb-td[data-v-5f215072]{padding:8px 12px}.btn[data-v-5f215072]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}", ""]);
// Exports
module.exports = exports;
